// Libraries
import { FormControl, RadioGroup, FormHelperText, FormLabel } from "@material-ui/core";
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React, { ReactElement } from "react";
import ReactHtmlParser from "react-html-parser";

// Core
import { isEmptyOrWhitespace } from "../../../../Core/Utils/Utils";

// Custom
import { BQSRadioButtonsStyle } from "./../BQSPrimitivesStyle";
import { isNullOrUndefined } from "Custom/Utils/Utils";

interface IProps {
    className?: string;
    displayName: string;
    execute: (value: any) => void;
    row?: boolean;
    value: any;
    validationMessage?: string;
}

export const BQSRadioButtons: React.FC<IProps> = (props: any) => {
    // #region Code Behind

    const radioButtonClasses = BQSRadioButtonsStyle();

    const displayGroupAsRow = (): boolean => {
        return !isNullOrUndefined(props.row) ? props.row : true;
    };

    const getClassName = (): string => {
        return classNames({
            BQSRadioButtons: true,
            [`${props.className}`]: !isEmptyOrWhitespace(props.className),
        });
    };

    const getDisplayName = (): ReactElement[] | string => {
        return !isEmptyOrWhitespace(props.displayName) ? ReactHtmlParser(props.displayName) : "";
    };

    const canDisplayName = (): boolean => {
        return !isEmptyOrWhitespace(props.displayName);
    };

    const getValidationMessage = (): string => {
        return !isEmptyOrWhitespace(props.validationMessage) ? props.validationMessage! : "";
    };

    const getValue = (): string => {
        return !isNullOrUndefined(props.value) ? props.value.toString() : "";
    };

    const isValidationMessageNotEmpty = (): boolean => {
        return !isEmptyOrWhitespace(props.validationMessage);
    };

    const renderChildrenWithProps = (): JSX.Element => {
        const childrenWithProps = React.Children.map(props.children, (child) => {
            return React.cloneElement(child as React.ReactElement<any>, {});
        });

        return <React.Fragment>{childrenWithProps}</React.Fragment>;
    };

    const onChange = (event: any) => {
        props.execute(event.target.value);
    };

    // #endregion Code Behind

    // #region Public Interface

    return useObserver(() => (
        <FormControl classes={radioButtonClasses} className={getClassName()} component="fieldset" error={isValidationMessageNotEmpty()}>
            {canDisplayName() && <FormLabel component="legend">{getDisplayName()}</FormLabel>}
            <RadioGroup onChange={onChange} row={displayGroupAsRow()} value={getValue()}>
                {renderChildrenWithProps()}
            </RadioGroup>
            {isValidationMessageNotEmpty() && <FormHelperText>{getValidationMessage()}</FormHelperText>}
        </FormControl>
    ));

    // #endregion Public Interface
};
